import {Component, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-popup',
  templateUrl: './confirm-popup.component.html'
})
export class ConfirmPopupComponent {

  @Input()
  public title: string;

  @Input()
  public message: string;

  constructor(public activeModal: NgbActiveModal) {
  }

}
